export default __webpack_public_path__ + "media/images/react_icons/flask-9682af1742b809a08126d29a28179f4c.svg";